import { createGlobalStyle } from 'styled-components';

import { GlobalStyleProps } from '@/types/styles';

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    height: 100%;
  }

  /* Kill the iOS horizontal rubberband: the page must never drag left/right
     with the thumb. overscroll-behavior-x stops the elastic bounce without
     making html a scroll container (which would break the mobile sticky
     headers); body keeps overflow-x: hidden to clip any real overflow. */
  html,
  body {
    overscroll-behavior-x: none;
    max-width: 100%;
  }

  body {
    background: ${(props) => props.theme.palette.background.default};
    margin: 0;
    overflow-x: hidden;
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }

  /* iOS auto-zooms when a focused field's font-size is < 16px (the viewport
     maximum-scale/user-scalable hints are ignored for this since iOS 10). Force
     every text input to 16px on touch/non-desktop widths so the keyboard never
     triggers a zoom. !important so it beats MUI/styled-components field styles.
     Desktop (>=1150, the header swap) is untouched — zoom-on-focus is mobile-only. */
  @media (max-width: 1149px) {
    input,
    textarea,
    select,
    .MuiInputBase-input {
      font-size: 16px !important;
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
`;

export default GlobalStyle;
